// TYPES
// FUNCTIONS
var logger = console;
export function getLogger() {
  return logger;
}
export function setLogger(newLogger) {
  logger = newLogger;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-query/es/core/logger.js
// module id = 168
// module chunks = 36